import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import type { ProfileState } from '../state/profile.state';
import { initialProfileState } from '../state/profile.state';
import {
  UpdateProfileAction,
  UpdateProfileActionSuccess,
  UpdateProfileActionFail,
  FetchProfileSuccess,
  FetchProfileError,
  FetchProfile,
} from '../action/profile.action';

const profileReducer = createReducer(
  initialProfileState,

  on(UpdateProfileAction, (state: ProfileState) => {
    const newState = {
      ...state,
      loading: true,
      loaded: false,
      error: null,
    };

    return newState;
  }),
  on(UpdateProfileActionSuccess, (state: ProfileState, { profile }) => {
    const newState = {
      ...state,
      profile: {
        ...profile,
      },
      loading: false,
      loaded: true,
    };

    return newState;
  }),

  on(UpdateProfileActionFail, (state: ProfileState, { error }) => {
    const newState = {
      ...state,
      loading: false,
      loaded: false,
      error,
    };

    return newState;
  }),

  on(FetchProfile, (state: ProfileState) => {
    const newState = {
      ...state,
      loading: true,
      loaded: false,
      error: null,
    };
    return newState;
  }),

  on(FetchProfileSuccess, (state: ProfileState, { profile }) => {
    const newState = {
      ...state,
      profile: {
        ...profile,
      },
      loading: false,
      loaded: true,
    };

    return newState;
  }),

  on(FetchProfileError, (state: ProfileState, { error }) => {
    const newState = {
      ...state,
      loading: false,
      loaded: false,
      error,
    };

    return newState;
  }),
);

export function ProfileReducer(state: ProfileState | undefined, action: Action) {
  return profileReducer(state, action);
}
